"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _SVGIconWithSizes;

var _default = (0, _createSvg.createSvg)('IconExternalLink', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M2 3C1.44771 3 1 3.44772 1 4L1 14C1 14.5523 1.44771 15 2 15L12 15C12.5523 15 13 14.5523 13 14V9C13 8.44772 12.5523 8 12 8C11.4477 8 11 8.44772 11 9V13H3L3 5L7 5C7.55228 5 8 4.55229 8 4C8 3.44772 7.55228 3 7 3L2 3Z', 'M10 3H11.5858L7.29289 7.29289C6.90237 7.68342 6.90237 8.31658 7.29289 8.70711C7.68342 9.09763 8.31658 9.09763 8.70711 8.70711L13 4.41421V6C13 6.55229 13.4477 7 14 7C14.5523 7 15 6.55229 15 6V2C15 1.44772 14.5523 1 14 1L10 1C9.44772 1 9 1.44772 9 2C9 2.55229 9.44772 3 10 3Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M12 2C12 1.44772 12.4477 1 13 1H18C18.5523 1 19 1.44772 19 2V7C19 7.55228 18.5523 8 18 8C17.4477 8 17 7.55228 17 7V4.41421L10.7071 10.7071C10.3166 11.0976 9.68342 11.0976 9.29289 10.7071C8.90237 10.3166 8.90237 9.68342 9.29289 9.29289L15.5858 3H13C12.4477 3 12 2.55228 12 2Z', 'M2 3C1.44772 3 1 3.44772 1 4V18C1 18.5523 1.44772 19 2 19H16C16.5523 19 17 18.5523 17 18V11C17 10.4477 16.5523 10 16 10C15.4477 10 15 10.4477 15 11V17H3V5H9C9.55228 5 10 4.55228 10 4C10 3.44772 9.55228 3 9 3H2Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M2 4C1.44772 4 1 4.44772 1 5L1 22C1 22.5523 1.44772 23 2 23L19 23C19.5523 23 20 22.5523 20 22V13C20 12.4477 19.5523 12 19 12C18.4477 12 18 12.4477 18 13V21H3L3 6L11 6C11.5523 6 12 5.55229 12 5C12 4.44771 11.5523 4 11 4L2 4Z', 'M15 3L19.5858 3L11.2929 11.2929C10.9024 11.6834 10.9024 12.3166 11.2929 12.7071C11.6834 13.0976 12.3166 13.0976 12.7071 12.7071L21 4.41421V9C21 9.55229 21.4477 10 22 10C22.5523 10 23 9.55229 23 9V2C23 1.44772 22.5523 1 22 1L15 1C14.4477 1 14 1.44772 14 2C14 2.55228 14.4477 3 15 3Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M3.5 5C2.67157 5 2 5.67158 2 6.5L2 28.5C2 29.3284 2.67157 30 3.5 30L25.5 30C26.3284 30 27 29.3284 27 28.5V17.5C27 16.6716 26.3284 16 25.5 16C24.6716 16 24 16.6716 24 17.5V27H5L5 8L15.5 8C16.3284 8 17 7.32843 17 6.5C17 5.67157 16.3284 5 15.5 5L3.5 5Z', 'M20.5 5L24.8787 5L15.4393 14.4393C14.8536 15.0251 14.8536 15.9749 15.4393 16.5607C16.0251 17.1464 16.9749 17.1464 17.5607 16.5607L27 7.12132V11.5C27 12.3284 27.6716 13 28.5 13C29.3284 13 30 12.3284 30 11.5V3.5C30 2.67157 29.3284 2 28.5 2L20.5 2C19.6716 2 19 2.67157 19 3.5C19 4.32843 19.6716 5 20.5 5Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));

exports.default = _default;